/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { ErrorToast } from '@/components/common';

export function handleError(error: any, fallbackMessage?: string) {
  let errorMessage = 'An unexpected error occurred.';

  if (error?.data) {
    if (error?.data?.error?.message) {
      errorMessage = error.data.error.message;
    } else if (error?.data?.error) {
      errorMessage = error.data.error;
    } else {
      errorMessage = error.data;
    }
  }

  // Show the error message as a toast notification
  ErrorToast(errorMessage ?? fallbackMessage);
}
